
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120.028 20C64.764 20 20 64.764 20 120.028s44.764 100.028 100.028 100.028S220 175.236 220 120.028C220 64.821 175.236 20 120.028 20zm0 7.903c24.612 0 47.756 9.596 65.143 26.983 17.386 17.386 26.983 40.53 26.983 65.142 0 24.612-9.597 47.756-26.983 65.143-17.387 17.386-40.531 26.983-65.143 26.983-24.612 0-47.756-9.597-65.142-26.983-17.387-17.443-26.983-40.587-26.983-65.143 0-24.555 9.596-47.756 26.983-65.142 17.386-17.387 40.53-26.983 65.142-26.983zm0 21.846c-30.482 0-55.32 24.838-55.32 55.32 0 21.225 12.024 39.628 29.579 48.885v15.354c0 13.266 10.782 24.048 24.048 24.048h3.387c13.265 0 24.047-10.782 24.047-24.048v-15.354c17.556-9.257 29.58-27.716 29.58-48.885-.057-30.539-24.838-55.32-55.321-55.32zm1.694 135.14c5.476-.001 10.274-2.823 13.096-7.17h-29.58c2.767 4.291 7.621 7.17 13.097 7.17h3.387zm15.58-15.581v-8.467h-34.604v8.467h34.604zm-26.249-18.289v-33.305c0-4.911 4.008-8.919 8.919-8.919h.451c4.911 0 8.919 4.008 8.919 8.919v33.248c-2.991.621-6.096.96-9.314.96-3.104 0-6.096-.339-8.975-.903zm9.37-50.579c9.541.001 17.33 7.791 17.33 17.33v30.652c.283-.113.621-.282.904-.395.564-.564 1.298-.847 2.088-1.016 15.467-7.677 26.136-23.596 26.136-41.885 0-25.854-20.999-46.853-46.853-46.853-25.854 0-46.853 20.999-46.853 46.853 0 19.644 12.25 36.522 29.467 43.466V117.77c0-9.539 7.789-17.329 17.33-17.33h.451z"}})])
          )
        }
      }
    